module.exports = __webpack_public_path__ + "static/img/wxchat_icon.2ce1d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxchat_icon.png
// module id = ujLZ
// module chunks = 1